// app/components/AosClientProvider.tsx
'use client';

import dynamic from 'next/dynamic';

const DynamicAosProvider = dynamic(
  () => import('@/app/components/DynamicAosProvider'),
  { ssr: false, loading: () => null }
);

export default function AosClientProvider() {
  return <DynamicAosProvider />;
}
